<template>
  <div class="loader">
    <div class="loader_inner"></div>
  </div>
</template>

<script>
export default {
  name: 'Preloader',
};
</script>

<style scoped>
.loader {
  background-color: rgba(0, 0, 0, 0.05);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 10020;
}
.loader .loader_inner {
  /*background-image: url('https://www.cherryhillfreeclinic.org/wp-content/uploads/2017/02/lg.rotating-squares-preloader-gif.gif');*/
  background-image: url('https://www.cdo.org.ua/templates/file/images/lg.rotating-squares-preloader-gif.gif');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  height: 80px;
  width: 80px;
  margin-top: -40px;
  margin-left: -40px;
  left: 50%;
  top: 50%;
  position: absolute;
}
</style>